import { useState, type FormEvent } from 'react';

interface Props {
  onPass: () => void;
}

/**
 * Single-field gate. Compares against VITE_DEMO_PASSCODE baked in at
 * build time. Per CLAUDE.md and Decision 20 this is UX friction, NOT
 * security — the bundle is publicly served, so the passcode is visible
 * to anyone who looks. It just keeps casual visitors out of the demo.
 */
export function PasscodeGate({ onPass }: Props) {
  const expected = import.meta.env.VITE_DEMO_PASSCODE ?? '';
  const [value, setValue] = useState('');
  const [error, setError] = useState<string | null>(null);

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!expected || value === expected) {
      onPass();
    } else {
      setError('合言葉が違うようです。');
    }
  };

  return (
    <div className="main center">
      <form className="gate-card" onSubmit={onSubmit}>
        <p className="gate-eyebrow">D-COMPASS × SENPAI</p>
        <h1>合言葉を入力してください</h1>
        <p className="lede">関係者向けのデモです。事前に共有された合言葉をどうぞ。</p>
        <input
          className="input"
          type="password"
          autoFocus
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            setError(null);
          }}
          placeholder="合言葉"
          aria-label="合言葉"
        />
        {error && <p className="error">{error}</p>}
        <div className="gate-actions">
          <button type="submit" className="btn">
            進む
          </button>
        </div>
      </form>
    </div>
  );
}
